//hook
import { UserConsumer } from '../../hooks/context/UserContext';

//mui
import { DialogProps } from '@mui/material/Dialog';

//mui icon
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import PauseIcon from '@mui/icons-material/Pause';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';


//translate
import { useTranslation } from 'react-i18next';
import i18n from "../../translate/i18n";

//type
import { driverProfileType } from "../../api/completedRole/type/CompletedRoleType"
import { Button } from '@mui/material';
interface DriverCardProps {
    setOpenAddDriver:(value: {open:boolean,scrollType: DialogProps['scroll']}) => void
    setSelectedDriver: (selectedDriver?: driverProfileType) => void
    element: driverProfileType
    setOpenDeleteConfirmation: (openDeleteConfirmation: boolean) => void
}

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

const DriverCard = ({setOpenAddDriver,setSelectedDriver , element, setOpenDeleteConfirmation}: DriverCardProps) => {
    const {t} = useTranslation()
    const {theme} = UserConsumer()
    return (
    <div className="rounded-2xl border border-gray-300 overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 group relative">
      <div
      className='px-2 py-1 rounded-lg !absolute !top-1 !right-1 !bg-red-500 !text-white cursor-pointer z-10'
      onClick={() => {setOpenDeleteConfirmation(true); setSelectedDriver(element);}}>
          <DeleteOutlineIcon/>
      </div>
        <div className="relative h-40 w-full group overflow-hidden rounded-t-[15px]">
            <img
                className="h-full w-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-[1.5]"
                src={`${storageURL}/${element.picture_url}`}
                alt="car_photo"
            />
        </div>
        <div className="p-3 mt-3">
            <p className="font-[600] truncate text-[20px]">{element.user?.full_name}</p>
            <div className='flex items-center gap-2 mt-2 max-sm:text-[14px]'>
                <MailOutlineIcon className='sm:!text-[16px] max-sm:!text-[14px]'/>
                <p>{element.user?.email}</p>
            </div>
            <div className="flex items-center gap-2 mt-2 max-sm:text-[14px]">
                { element.availability_status === "off" 
                ?<CancelIcon  className="!text-red-500 sm:!text-[16px] max-sm:!text-[14px]"/>
                :element.availability_status === "available"
                    ?<CheckCircleIcon  className="!text-customerColor sm:!text-[16px] max-sm:!text-[14px]"/>
                    :<PauseIcon className="!text-[#FF8F3A] sm:!text-[16px] max-sm:!text-[14px]"/>
                }
                <p>{element.availability_status === "off" ? t("off") : element.availability_status === "available" ? t("available") : t("busy")}</p>
            </div>
            <div className="flex items-center gap-2 mt-2 max-sm:text-[14px]">
                { element.is_confirmed === 0
                ?<PauseCircleFilledIcon  className="!text-[#FFC107] sm:!text-[16px] max-sm:!text-[14px]"/>
                :<CheckCircleIcon  className="!text-customerColor sm:!text-[16px] max-sm:!text-[14px]"/>
                }
                <p>{element.is_confirmed === 0 ? t("driver_unconfirmed") : t("driver_confirmed")}</p>
            </div>
            <div className="flex items-center gap-2 mt-2 max-sm:text-[14px]">
                <MonetizationOnOutlinedIcon className="sm:!text-[16px] max-sm:!text-[14px]" />
                <div>
                    <span className="ml-1">{element.hourly_desired_wage}</span>
                    <span className="ml-1 text-[12px]">{t("per_hour")}</span>
                </div>
            </div>
            <div className="flex items-center gap-2 mt-2 max-sm:text-[14px]">
                <MonetizationOnOutlinedIcon className="sm:!text-[16px] max-sm:!text-[14px]" />
                <div>
                    <span className="ml-1">{element.extra_hour_price}</span>
                    <span className="ml-1 text-[12px]">{t("extra_hour")}</span>
                </div>
            </div>
            <div className="flex items-center gap-2 mt-2 max-sm:text-[14px]">
                <Button 
                onClick={()=>{setSelectedDriver(element); setOpenAddDriver({open: true, scrollType: "paper"})}}
                className={`!text-white !w-full flex gap-2 ${theme === "client" ? "!bg-customerColor" : "!bg-paretnerColor"}`}>
                    <VisibilityIcon/>
                    <p>{t("view_details")}</p>
                </Button>
            </div>
        </div>
    </div>
    )
}

export default DriverCard